const styles = (currentTheme) => ({
  appBar: {
    top: 0,
    overflow: 'hidden',
    maxHeight: 57
  },
  menuButton: {
    marginLeft: 10
  },
  iconsRightContainer: {
    marginLeft: 20,
    display: 'flex',
    color: currentTheme.appBarMenuButtonColor
  },
  tabsScrollbars: {
    overflowX: 'overlay',
    overflowY: 'hidden'
  },
  iconButton: {
    fill: currentTheme.appBarMenuButtonColor
  }
});

export default styles;
